"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToVoucherType = exports.VoucherTypeSchema = exports.VoucherType = exports.VoucherCodeSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
exports.VoucherCodeSchema = typebox_1.Type.String({
    title: "Voucher code",
    description: "Voucher code",
    format: "uuid",
    examples: ["a6f7a8c0-d857-4e8a-9c8c-819a49229d63"],
});
var VoucherType;
(function (VoucherType) {
    VoucherType["NO_COMMISSION"] = "NO_COMMISSION";
})(VoucherType = exports.VoucherType || (exports.VoucherType = {}));
exports.VoucherTypeSchema = (0, core_1.StringUnion)([VoucherType.NO_COMMISSION], {
    title: "Voucher type",
    description: "The discount applied by the voucher",
});
exports.castToVoucherType = (0, cast_1.castToEnum)(VoucherType);
